module.exports = __webpack_public_path__ + "static/img/PU_ISO9001.eb768241.jpg";